<!-- 创建时间2024/02/29 11:22:50 -->
<!-- 创建人：Zhao bing bing -->
<!-- 组件描述：知识库选择 -->
<template>
  <yxt-drawer
    destroy-on-close
    :before-close="(done) => done()"
    :title="$t('pc_kng_lbl_selectkng')"
    :visible.sync="visible"
    size="960px">
    <yxtbiz-select-newkng v-model="selected" :max="selectableLength"/>
    <div slot="footer">
      <yxt-button plain @click="cancel">{{ $t('pc_kng_common_btn_cancel') }}</yxt-button>
      <yxt-button type="primary" @click="confirm">{{ $t('pc_kng_common_btn_confirm') }}</yxt-button>
    </div>
  </yxt-drawer>
</template>

<script>
export default {
  name: 'kng-lib-selector',
  inject: ['getSelectableLength'],
  data() {
    return {
      visible: false,
      selected: []
    };
  },
  computed: {
    selectableLength() {
      return this.getSelectableLength();
    }
  },
  methods: {
    init() {
      this.selected = [];
      return new Promise((resolve, reject) => {
        this.visible = true;
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    confirm() {
      const data = this.selected.map(item => {
        const { fileId, fileSize, title, fileType, fileExt, pageSize, coverUrl, storageType, storageLocationId, storageLocationName } = item;
        return {
          title,
          fileId,
          fileSize,
          extension: fileExt,
          fileClass: fileType,
          fileType,
          pageSize,
          coverUrl,
          envFlag: storageType === 2 ? 0 : 1,
          serverGroupId: storageLocationId,
          serverGroupName: storageLocationName,
          courseFrom: 1 // 知识库来源
        };
      });
      this.resolve(data);
      this.visible = false;
    },
    cancel() {
      this.visible = false;
      this.reject();
    }
  }
};
</script>